module.exports = __webpack_public_path__ + "static/img/6.d6fc9bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/14/sp/6.png
// module id = OeYo
// module chunks = 0